import type { ReportMetricRowDefinition } from 'app/modules/analytics/modules/reports/components/reportPreview/ReportPlatformMetricRows';

export interface ReportMetricRowsConfig {
  definitions: ReportMetricRowDefinition[];
  maxColumns: number;
}

export const FACEBOOK_REPORT_PERFORMANCE_ROW_1: ReportMetricRowDefinition[] = [
  {
    metricKey: 'reach',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.reachTooltip',
  },
  {
    metricKey: 'media_views',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.mediaViewsTooltip',
  },
  {
    metricKey: 'engagements',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.engagementTooltip',
  },
  {
    metricKey: 'engagement_rate',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.engagementRateTooltip',
  },
  {
    metricKey: 'followers_gained',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.newFollowersTooltip',
  },
];

export const FACEBOOK_REPORT_PERFORMANCE_ROW_2: ReportMetricRowDefinition[] = [
  {
    metricKey: 'clicks',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.clicksTooltip',
  },
  {
    metricKey: 'comments',
    sectionKind: 'performance',
  },
  {
    metricKey: 'video_views',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.viewsTooltip',
  },
  {
    metricKey: 'followers_lost',
    sectionKind: 'performance',
  },
];

export const FACEBOOK_REPORT_CONTENT_ROW_1: ReportMetricRowDefinition[] = [
  {
    metricKey: 'impressions',
    sectionKind: 'content',
    tooltipKey: 'analyticsContent.metrics.viewsTooltip',
  },
  {
    metricKey: 'reach',
    sectionKind: 'content',
    tooltipKey: 'analyticsContent.metrics.reachTooltip',
  },
  {
    metricKey: 'engagements',
    sectionKind: 'content',
    tooltipKey: 'analyticsContent.metrics.engagementTooltip',
  },
  {
    metricKey: 'reactions',
    sectionKind: 'content',
    tooltipKey: 'analyticsContent.metrics.reactionsTooltip',
  },
];

export const FACEBOOK_REPORT_CONTENT_ROW_2: ReportMetricRowDefinition[] = [
  {
    metricKey: 'likes',
    sectionKind: 'content',
  },
  {
    metricKey: 'comments',
    sectionKind: 'content',
  },
  {
    metricKey: 'shares',
    sectionKind: 'content',
  },
  {
    metricKey: 'video_views',
    sectionKind: 'content',
    tooltipKey: 'analyticsContent.metrics.videoViewsTooltip',
  },
];

export const FACEBOOK_REPORT_PERFORMANCE_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: FACEBOOK_REPORT_PERFORMANCE_ROW_1,
    maxColumns: 5,
  },
  {
    definitions: FACEBOOK_REPORT_PERFORMANCE_ROW_2,
    maxColumns: 4,
  },
];

export const FACEBOOK_REPORT_CONTENT_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: FACEBOOK_REPORT_CONTENT_ROW_1,
    maxColumns: 4,
  },
  {
    definitions: FACEBOOK_REPORT_CONTENT_ROW_2,
    maxColumns: 4,
  },
];

export const INSTAGRAM_REPORT_PERFORMANCE_ROW_1: ReportMetricRowDefinition[] = [
  {
    metricKey: 'reach',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.reachTooltip',
  },
  {
    metricKey: 'views',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.viewsTooltip',
  },
  {
    metricKey: 'engagements',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.engagementTooltip',
  },
  {
    metricKey: 'engagement_rate',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.engagementRateTooltip',
  },
  {
    metricKey: 'followers_gained',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.newFollowersTooltip',
  },
];

export const INSTAGRAM_REPORT_PERFORMANCE_ROW_2: ReportMetricRowDefinition[] = [
  {
    metricKey: 'accounts_engaged',
    sectionKind: 'performance',
  },
  {
    metricKey: 'profile_activity_bio_link',
    sectionKind: 'performance',
  },
  {
    metricKey: 'followers_lost',
    sectionKind: 'performance',
  },
  {
    metricKey: 'reach_nonfan',
    sectionKind: 'performance',
  },
];

export const INSTAGRAM_REPORT_PERFORMANCE_ROW_3: ReportMetricRowDefinition[] = [
  {
    metricKey: 'impressions',
    sectionKind: 'performance',
  },
  {
    metricKey: 'clicks',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.clicksTooltip',
  },
  {
    metricKey: 'video_views',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.viewsTooltip',
  },
];

export const INSTAGRAM_REPORT_CONTENT_ROW_1: ReportMetricRowDefinition[] =
  FACEBOOK_REPORT_CONTENT_ROW_1;

export const INSTAGRAM_REPORT_CONTENT_ROW_2: ReportMetricRowDefinition[] =
  FACEBOOK_REPORT_CONTENT_ROW_2;

export const INSTAGRAM_REPORT_PERFORMANCE_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: INSTAGRAM_REPORT_PERFORMANCE_ROW_1,
    maxColumns: 5,
  },
  {
    definitions: INSTAGRAM_REPORT_PERFORMANCE_ROW_2,
    maxColumns: 4,
  },
  {
    definitions: INSTAGRAM_REPORT_PERFORMANCE_ROW_3,
    maxColumns: 4,
  },
];

export const INSTAGRAM_REPORT_CONTENT_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: INSTAGRAM_REPORT_CONTENT_ROW_1,
    maxColumns: 5,
  },
  {
    definitions: INSTAGRAM_REPORT_CONTENT_ROW_2,
    maxColumns: 4,
  },
];

export const LINKEDIN_REPORT_PERFORMANCE_ROW_1: ReportMetricRowDefinition[] = [
  {
    metricKey: 'impressions',
    sectionKind: 'performance',
  },
  {
    metricKey: 'reach',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.reachTooltip',
  },
  {
    metricKey: 'engagements',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.engagementTooltip',
  },
  {
    metricKey: 'engagement_rate',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.engagementRateTooltip',
  },
];

export const LINKEDIN_REPORT_PERFORMANCE_ROW_2: ReportMetricRowDefinition[] = [
  {
    metricKey: 'followers_gained',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.newFollowersTooltip',
  },
  {
    metricKey: 'followers',
    sectionKind: 'performance',
  },
  {
    metricKey: 'clicks',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.clicksTooltip',
  },
  {
    metricKey: 'comments',
    sectionKind: 'performance',
  },
];

export const LINKEDIN_REPORT_PERFORMANCE_ROW_3: ReportMetricRowDefinition[] = [
  {
    metricKey: 'followers_lost',
    sectionKind: 'performance',
  },
  {
    metricKey: 'reactions',
    sectionKind: 'performance',
  },
  {
    metricKey: 'video_views',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.viewsTooltip',
  },
];

export const LINKEDIN_REPORT_CONTENT_ROW_1: ReportMetricRowDefinition[] =
  FACEBOOK_REPORT_CONTENT_ROW_1;

export const LINKEDIN_REPORT_CONTENT_ROW_2: ReportMetricRowDefinition[] =
  FACEBOOK_REPORT_CONTENT_ROW_2;

export const LINKEDIN_REPORT_PERFORMANCE_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: LINKEDIN_REPORT_PERFORMANCE_ROW_1,
    maxColumns: 4,
  },
  {
    definitions: LINKEDIN_REPORT_PERFORMANCE_ROW_2,
    maxColumns: 4,
  },
  {
    definitions: LINKEDIN_REPORT_PERFORMANCE_ROW_3,
    maxColumns: 4,
  },
];

export const LINKEDIN_REPORT_CONTENT_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: LINKEDIN_REPORT_CONTENT_ROW_1,
    maxColumns: 4,
  },
  {
    definitions: LINKEDIN_REPORT_CONTENT_ROW_2,
    maxColumns: 4,
  },
];

export const GENERAL_REPORT_PERFORMANCE_ROW_1: ReportMetricRowDefinition[] = [
  {
    metricKey: 'reach',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.reachTooltip',
  },
  {
    metricKey: 'views',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.viewsTooltip',
  },
  {
    metricKey: 'engagements',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.engagementTooltip',
  },
  {
    metricKey: 'engagement_rate',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.engagementRateTooltip',
  },
];

export const GENERAL_REPORT_PERFORMANCE_ROW_2: ReportMetricRowDefinition[] = [
  {
    metricKey: 'followers_gained',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.newFollowersTooltip',
  },
  {
    metricKey: 'followers',
    sectionKind: 'performance',
  },
  {
    metricKey: 'clicks',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.clicksTooltip',
  },
  {
    metricKey: 'comments',
    sectionKind: 'performance',
  },
];

export const GENERAL_REPORT_PERFORMANCE_ROW_3: ReportMetricRowDefinition[] = [
  {
    metricKey: 'reactions',
    sectionKind: 'performance',
  },
  {
    metricKey: 'video_views',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.viewsTooltip',
  },
  {
    metricKey: 'followers_lost',
    sectionKind: 'performance',
  },
  {
    metricKey: 'likes',
    sectionKind: 'performance',
  },
];

export const GENERAL_REPORT_CONTENT_ROW_1: ReportMetricRowDefinition[] =
  FACEBOOK_REPORT_CONTENT_ROW_1;

export const GENERAL_REPORT_CONTENT_ROW_2: ReportMetricRowDefinition[] =
  FACEBOOK_REPORT_CONTENT_ROW_2;

export const GENERAL_REPORT_PERFORMANCE_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: GENERAL_REPORT_PERFORMANCE_ROW_1,
    maxColumns: 4,
  },
  {
    definitions: GENERAL_REPORT_PERFORMANCE_ROW_2,
    maxColumns: 4,
  },
  {
    definitions: GENERAL_REPORT_PERFORMANCE_ROW_3,
    maxColumns: 4,
  },
];

export const GENERAL_REPORT_CONTENT_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: GENERAL_REPORT_CONTENT_ROW_1,
    maxColumns: 4,
  },
  {
    definitions: GENERAL_REPORT_CONTENT_ROW_2,
    maxColumns: 4,
  },
];

// Metric keys are constrained to the backend TikTok performance whitelist
// (engaged_audience / engagement / engagement_rate are not accepted there).
export const TIKTOK_REPORT_PERFORMANCE_ROW_1: ReportMetricRowDefinition[] = [
  {
    metricKey: 'video_views',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.videoViewsTooltip',
  },
  {
    metricKey: 'video_views_unique',
    sectionKind: 'performance',
  },
  {
    metricKey: 'reach',
    sectionKind: 'performance',
    tooltipKey: 'analyticsPerformance.metrics.reachTooltip',
  },
  {
    metricKey: 'followers',
    sectionKind: 'performance',
  },
];

export const TIKTOK_REPORT_PERFORMANCE_ROW_2: ReportMetricRowDefinition[] = [
  {
    metricKey: 'likes',
    sectionKind: 'performance',
  },
  {
    metricKey: 'comments',
    sectionKind: 'performance',
  },
  {
    metricKey: 'shares',
    sectionKind: 'performance',
  },
];

// Metric keys are constrained to the backend TikTok content whitelist
// (engagement_rate / saves are not accepted there).
export const TIKTOK_REPORT_CONTENT_ROW_1: ReportMetricRowDefinition[] = [
  {
    metricKey: 'video_views',
    sectionKind: 'content',
    tooltipKey: 'analyticsContent.metrics.videoViewsTooltip',
  },
  {
    metricKey: 'reach',
    sectionKind: 'content',
    tooltipKey: 'analyticsContent.metrics.reachTooltip',
  },
  {
    metricKey: 'engagements',
    sectionKind: 'content',
    tooltipKey: 'analyticsContent.metrics.engagementTooltip',
  },
];

export const TIKTOK_REPORT_CONTENT_ROW_2: ReportMetricRowDefinition[] = [
  {
    metricKey: 'likes',
    sectionKind: 'content',
  },
  {
    metricKey: 'comments',
    sectionKind: 'content',
  },
  {
    metricKey: 'shares',
    sectionKind: 'content',
  },
];

export const TIKTOK_REPORT_PERFORMANCE_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: TIKTOK_REPORT_PERFORMANCE_ROW_1,
    maxColumns: 4,
  },
  {
    definitions: TIKTOK_REPORT_PERFORMANCE_ROW_2,
    maxColumns: 4,
  },
];

export const TIKTOK_REPORT_CONTENT_ROWS: ReportMetricRowsConfig[] = [
  {
    definitions: TIKTOK_REPORT_CONTENT_ROW_1,
    maxColumns: 4,
  },
  {
    definitions: TIKTOK_REPORT_CONTENT_ROW_2,
    maxColumns: 4,
  },
];
